<template>
  <v-dialog :value="value" persistent max-width="900" @click:outside="closeDialog()">
    <v-card color="fill">
      <v-card-title class="my-0 py-0 pt-0 heading-6">
        <v-row justify="space-between" class="my-2">
          <v-col class="ma-0 pa-0" align="start">
            <div class="text-no-wrap">Saved Exports</div>
          </v-col>
          <v-col class="pa-0 ma-0 pr-2" align="end">
            <v-btn icon @click="closeDialog()">
              <v-icon dense>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-tabs v-model="tab" grow>
        <v-tab>Templates</v-tab>
        <v-tab>Scheduled Deliveries</v-tab>
      </v-tabs>

      <ExportTemplatesPanel v-if="tab === 0" />
      <ScheduledExportsPanel v-if="tab === 1" />
    </v-card>
  </v-dialog>
</template>
<script>
import ExportTemplatesPanel from '@/components/ExportTemplatesPanel.vue'
import ScheduledExportsPanel from '@/components/ScheduledExportsPanel.vue'

export default {
  name: 'SavedExportsModal',
  components: { ExportTemplatesPanel, ScheduledExportsPanel },
  props: {
    value: Boolean
  },
  data () {
    return {
      tab: 0
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SavedExportsModal.vue